import React, { useEffect, useState } from "react";
import Button from "../../button/Button";
import Box from "../../box/Box";
import BuyBoxFooter from "../shared/BuyBoxFooter";
import SubscriptionRadioButton from "./SubscriptionRadioButton";
import { useAddToBag } from "../../hooks/useAddToBag";
import { RadioGroup } from "onnit-ui/lib/form/toggle/RadioGroup";
import Text from "onnit-ui/lib/text";
import { ProductStatus } from "onnit-ui/lib/@types/enums/ProductStatus";
import { getProductStatus } from "onnit-ui/lib/buybox/utils";
import OOSView from "onnit-ui/lib/buybox/shared/OOSView";
import DiscontinuedView from "onnit-ui/lib/buybox/shared/DiscontinuedView";
var ProductSelectView = function (_a) {
    var _b;
    var selectedProduct = _a.selectedProduct, products = _a.products, onProductChange = _a.onProductChange, freeShippingThreshold = _a.freeShippingThreshold, onSuccess = _a.onSuccess, onError = _a.onError, children = _a.children, addToBagMiddleware = _a.addToBagMiddleware, _c = _a.showFooter, showFooter = _c === void 0 ? true : _c, promoDiscountConfigs = _a.promoDiscountConfigs, buyOnceProduct = _a.buyOnceProduct;
    var _d = useAddToBag({ onSuccess: onSuccess, onError: onError }), isAddingToBag = _d.isAddingToBag, addToBag = _d.addToBag;
    var _e = useState(30), subscriptionInterval = _e[0], setSubscriptionInterval = _e[1];
    var _f = useState(0), adjustedPrice = _f[0], setAdjustedPrice = _f[1];
    var _g = useState(("")), radioState = _g[0], setRadioState = _g[1];
    var _h = useState(getProductStatus(selectedProduct)), selectedProductStatus = _h[0], setSelectedProductStatus = _h[1];
    var buyOnceProductStatus = (_b = getProductStatus(buyOnceProduct)) !== null && _b !== void 0 ? _b : null;
    useEffect(function () {
        var _a;
        setSubscriptionInterval(Number(selectedProduct.meta["default-subscription-frequency"]));
        setRadioState(selectedProduct.id);
        var adjustedPrice = parseFloat(selectedProduct.price_raw);
        var subscriptionEligible = (_a = selectedProduct.meta["subscription-eligible"] === "yes") !== null && _a !== void 0 ? _a : false;
        var subscriptionPrice = selectedProduct.price_subscription_raw || 0.0;
        if (subscriptionEligible) {
            adjustedPrice = subscriptionPrice;
        }
        setAdjustedPrice(adjustedPrice);
    }, [selectedProduct]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, null,
            React.createElement(RadioGroup, { labelPosition: "left", value: radioState, onChange: function (_a) {
                    var value = _a.target.value;
                    setRadioState(value);
                    var product = products.find(function (p) { return p.id === parseInt(value); });
                    if (product) {
                        onProductChange && onProductChange(product);
                    }
                } }, products.map(function (product) {
                {
                    return (React.createElement(SubscriptionRadioButton, { key: product.name, product: product, freeShippingThreshold: freeShippingThreshold, promoDiscountConfigs: promoDiscountConfigs }));
                }
            })),
            selectedProductStatus === ProductStatus.InStock &&
                (React.createElement(Button, { mt: 5, width: 1, display: "block", style: { padding: "22px 8px 18px" }, p: 0, onClick: function () {
                        var config = {
                            product_id: selectedProduct.id,
                            quantity: 1,
                            subscription_interval: subscriptionInterval,
                        };
                        if (addToBagMiddleware) {
                            addToBagMiddleware(config)
                                .then(function (newConfig) {
                                addToBag(newConfig);
                            })
                                .catch(console.error);
                        }
                        else {
                            addToBag(config);
                        }
                    }, disabled: isAddingToBag }, isAddingToBag
                    ? "Adding..."
                    : "Add to Bag & Subscribe")),
            selectedProductStatus === ProductStatus.OutOfStock && (React.createElement(OOSView, { product: selectedProduct })),
            selectedProductStatus === ProductStatus.Discontinued && (React.createElement(DiscontinuedView, null))),
        buyOnceProduct && buyOnceProductStatus === ProductStatus.InStock && (React.createElement(Text, { as: "button", mt: 6, mx: "auto", fontWeight: "bold", textTransform: "uppercase", onClick: function () {
                var config = {
                    product_id: buyOnceProduct.id,
                    quantity: 1,
                    subscription_interval: null,
                };
                if (addToBagMiddleware) {
                    addToBagMiddleware(config)
                        .then(function (newConfig) {
                        addToBag(newConfig);
                    })
                        .catch(console.error);
                }
                else {
                    addToBag(config);
                }
            } }, isAddingToBag
            ? "Adding to bag..."
            : "Buy once for ".concat(buyOnceProduct.price, " + shipping"))),
        children,
        showFooter && (React.createElement(BuyBoxFooter, { adjustedPrice: adjustedPrice, freeShippingThreshold: freeShippingThreshold }))));
};
export default ProductSelectView;
//# sourceMappingURL=ProductSelectView.js.map